export const volumes = [
  {
    numeral: "I",
    name: "The Case Snapshot System™",
    tagline: "Stop staring at a blank page.",
    intro: [
      "Before you can organize a strategy, you need to know exactly what you're looking at.",
      "In Volume I, I'll show you how to create a structured case snapshot that organizes the most important information before you start thinking about mechanics.",
    ],
    listLabel: "You'll work through:",
    items: ["Patient and case overview", "Chief concerns", "Diagnostic information", "Clinical findings", "Key observations", "Missing information", "Important limitations", "Initial case questions", "Case summary"],
    output: "A single Case Snapshot you can use as the starting point for the entire Command Center.",
    color: "bg-step-blue",
    flow: false,
  },
  {
    numeral: "II",
    name: "The Problem Board™",
    tagline: "Turn scattered findings into a structured problem list.",
    intro: [
      "A finding isn't automatically a treatment problem.",
      "This volume helps you separate what you see from what it means — and from what may need to change.",
    ],
    listLabel: "You'll learn how to organize:",
    items: ["Clinical findings", "Functional considerations", "Skeletal considerations", "Dental considerations", "Esthetic considerations", "Occlusal considerations", "Potential treatment problems", "Missing information", "Questions requiring further evaluation"],
    output: "A prioritized Problem Board instead of a collection of disconnected observations.",
    color: "bg-step-green",
    flow: false,
  },
  {
    numeral: "III",
    name: "The Objective & Priority Matrix™",
    tagline: "Decide what matters before deciding what moves.",
    intro: [
      "One of the easiest ways to create confusion is to jump directly from a finding to a movement.",
      "This volume helps you build the bridge: Problem → Objective → Priority. You'll also learn to distinguish between what you want to accomplish and how you might eventually accomplish it.",
    ],
    listLabel: "You'll organize:",
    items: ["Primary objectives", "Secondary objectives", "Supporting objectives", "Treatment priorities", "Dependencies", "Potential conflicts", "Objectives that may need reassessment"],
    output: "A clear hierarchy of treatment objectives and priorities.",
    color: "bg-step-orange",
    flow: false,
  },
  {
    numeral: "IV",
    name: "The Constraint & Movement Map™",
    tagline: "Know what needs to be considered before building the sequence.",
    intro: [
      "Before deciding how a case should progress, you need to identify the factors that can influence the strategy.",
      "The purpose isn't to prescribe a universal clinical solution. It's to help you make the relevant planning considerations visible.",
    ],
    listLabel: "Inside this volume, you'll map:",
    items: ["Important constraints", "Anchorage considerations", "Stability requirements", "Intended movements", "Movement priorities", "Areas requiring control", "Potential conflicts", "Dependencies between movements", "Areas requiring additional review"],
    output: "A visual Constraint & Movement Map that gives your strategy structure.",
    color: "bg-step-purple",
    flow: false,
  },
  {
    numeral: "V",
    name: "The Case Sequence Board™",
    tagline: "Turn a list of objectives into a logical roadmap.",
    intro: [
      "A treatment strategy isn't simply a list of things you want to accomplish. Order matters.",
      "Instead of repeatedly asking \"What should I think about next?\" you'll have a structured sequence to review.",
    ],
    listLabel: "You'll identify:",
    items: ["What needs to be considered first", "What may be addressed together", "What should wait", "What depends on another step", "Where reassessment belongs", "When a phase should be reviewed", "What needs to happen before finishing"],
    output: "A visual Case Sequence Board.",
    color: "bg-step-red",
    flow: false,
  },
  {
    numeral: "VI",
    name: "The Final Case Command Center™",
    tagline: "Bring the entire case together on one visual strategy.",
    intro: [
      "This is where everything comes together — into one reusable visual planning document, plus a final review process to look at the case as a whole before moving forward.",
    ],
    listLabel: "You'll combine:",
    items: ["Case Snapshot", "Problem Board", "Objectives", "Priorities", "Constraints", "Movement Considerations", "Sequence", "Review"],
    output: "THE ORTHO CASE COMMAND CENTER™ — a one-page visual representation of the strategy you've built.",
    color: "bg-step-teal",
    flow: true,
  },
];
